import jQuery from "jquery";
(function (far, $) {
  far.gdpr = {};

  //#region Public functions ====================================================

  far.gdpr.initialize = function () {
    wireRadioButtons();
    wireLinks();
    ensureFocus();
  };

  //#endregion

  //#region Private functions ===================================================

  function wireLinks() {
    $(".js-gdpr-information").click(function (e) {
      e.preventDefault();
      far.modal.show("#gdprinfo");
    });
  }

  function wireRadioButtons() {
    $("#gdpr1").change(function () {
      uncheck("#gdpr2");
    });
    $("#gdpr2").change(function () {
      uncheck("#gdpr1");
    });
  }

  function uncheck(target) {
    $(target).prop("checked", false);
  }

  function ensureFocus() {
    var href = document.location.href;
    if (
      href.indexOf("updateaction=return") > 0 &&
      href.indexOf("#gdpr") === -1
    ) {
      document.location.hash = "gdpr";
    }
  }

  //#endregion
})(window.far || (window.far = {}), jQuery);
